<template>
  <!-- Plantillas 2 a 5: el detalle con el diseño de su portada -->
  <N2DetalleServicio v-if="Servicio && disenoPropio" :servicio="Servicio" :anterior="prevService" :siguiente="nextService"
    :desde-inicio="isFromHome" :solicitud="mostrarSolicitud" :enlace-solicitud="accesoSolicitud.enlace('servicios', tramiteServicio)"
    :documentos="documentosTramite" :guia="guiaTramite" />
  <div v-else-if="Servicio" :id="'Servicio-'+Servicio.Id">
    <!-- Start Breadcrump Area  -->
    <div class="rn-page-title-area pt--120 pb--190 banner-service-details-notin" style="position: relative; z-index: 1; overflow: hidden;">
      <div v-if="img" class="bg_media" :style="{ backgroundImage: img, filter: imgFiltro, WebkitFilter: imgFiltro, position: 'absolute', inset: 0, zIndex: -1, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }"></div>
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="rn-page-title text-center pt--100">
              <h2 class="headingtitle">{{ Servicio.Titulo }}</h2>
              <h3 v-if="Servicio.Subtitulo">{{ Servicio.Subtitulo }}</h3>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->

    <div class="rn-service-details rn-section-gap bg_color--1 content-service-details-notin">
      <v-container>
        <v-row>
          <v-col lg="12">
            <div class="inner">
              <!-- Start Single Content  -->
              <v-row class="pb--80 align-items-center">
                <v-col lg="8" md="8" cols="12" class="content">
                  <div class="mt_md--30 mt_sm--30 text-justify">
                    <div class="content-service-details-notin" v-thtml="Servicio.Contenido"/>
                  </div>
                </v-col>
                <v-col lg="4" md="4" cols="12" v-if="Servicio.Imagen">
                  <div class="thumb">
                    <img class="w-100" :style="{ filter: imgFiltro, WebkitFilter: imgFiltro }" :src="imagenIDtoSRC(Servicio.Imagen)" alt="Service Images" />
                  </div>
                </v-col>
              </v-row>
              <!-- End Single Content  -->
              
              <!-- Solicitar este encargo online -->
              <div v-if="mostrarSolicitud" class="servicio-solicitud mb-10">
                <div class="servicio-solicitud__cuerpo">
                  <p class="servicio-solicitud__titulo">{{ tSolicitud('¿Quiere hacer este encargo con nosotros?') }}</p>
                  <p class="servicio-solicitud__texto">{{ tSolicitud('Envíenos sus datos y la documentación por internet y le contactaremos para prepararlo.') }}</p>
                  <!-- Qué tendrá que preparar (documentación del encargo en el catálogo de la notaría) -->
                  <div v-if="documentosTramite.length" class="servicio-solicitud__docs">
                    <p class="servicio-solicitud__docs-titulo">{{ tSolicitud('Para empezar, tenga a mano:') }}</p>
                    <ul>
                      <li v-for="d in documentosTramite" :key="d.nombre">
                        <v-icon size="18">mdi-file-document-outline</v-icon>
                        <span>{{ d.nombre }}<em v-if="!d.obligatorio"> · {{ tSolicitud('Si procede') }}</em></span>
                      </li>
                    </ul>
                    <p class="servicio-solicitud__docs-nota">{{ tSolicitud('Puede adjuntarlos en el encargo online o aportarlos más adelante.') }}</p>
                  </div>
                  <NuxtLink v-if="guiaTramite" class="servicio-solicitud__guia" :to="guiaTramite">{{ tSolicitud('Más información') }}</NuxtLink>
                </div>
                <NuxtLink class="servicio-solicitud__boton" :to="accesoSolicitud.enlace('servicios', tramiteServicio)">
                  {{ tSolicitud('Hacerlo online') }}
                </NuxtLink>
              </div>

              <!-- Navigation Previous/Next -->
              <v-divider class="mb-10"></v-divider>
              <v-row class="navigation-services mt-4" v-if="prevService || nextService">
                <v-col cols="12" sm="6" class="text-left mb-6 mb-sm-0" v-if="prevService">
                  <NuxtLink :to="'/servicios/' + prevService.Slug + (isFromHome ? '?from=home' : '')" class="d-flex align-center nav-link-notin">
                    <v-icon large class="mr-2">mdi-chevron-left</v-icon>
                    <div style="max-width: calc(100% - 40px)">
                      <span class="d-block caption text--secondary">{{ $t('anterior') }}</span>
                      <span class="d-block font-weight-bold subtitle-2 text-wrap" style="line-height: 1.2;">{{ prevService.Titulo }}</span>
                    </div>
                  </NuxtLink>
                </v-col>
                <v-col cols="12" sm="6" class="text-right" v-if="nextService" :offset-sm="prevService ? 0 : 6">
                  <NuxtLink :to="'/servicios/' + nextService.Slug + (isFromHome ? '?from=home' : '')" class="d-flex align-center justify-end nav-link-notin text-right">
                    <div style="max-width: calc(100% - 40px)">
                      <span class="d-block caption text--secondary">{{ $t('siguiente') }}</span>
                      <span class="d-block font-weight-bold subtitle-2 text-wrap" style="line-height: 1.2;">{{ nextService.Titulo }}</span>
                    </div>
                    <v-icon large class="ml-2">mdi-chevron-right</v-icon>
                  </NuxtLink>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script setup lang="ts">
// Plantillas 2 a 5 (refs: https://trello.com/c/3g3PTnq5, https://trello.com/c/MGgrmuPY, https://trello.com/c/XU15s9gl, https://trello.com/c/0Ma2vfxV)
import N2DetalleServicio from '../../components/notaria2/N2DetalleServicio.vue'
import { useDisenoPropio } from '../../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { ref, computed, toRaw } from 'vue';
import { useStore } from '../../store/index'
const store = useStore()
import { useUtils, useMetaTags } from '#imports';
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
import { useRoute, useRouter } from 'vue-router';
import type { SeoPagina } from '../../composables/metaTags'
import { textoPlano, recortar, fechaIso } from '../../composables/useSeoUrls'
const route = useRoute()
const router = useRouter()
const Servicio = ref(null)

// Botón "Hacerlo online" (se activa en el panel: Trámites online → Configuración)
import { onMounted } from 'vue'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { useSolicitudWeb } from '../../composables/useSolicitudWeb'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tramiteSeoPorCodigo } from '../../data/tramitesSeo'
const accesoSolicitud = useAccesoSolicitud()
const { tipos: tiposSolicitud, cargarCatalogo: cargarCatalogoSolicitud } = useSolicitudWeb()

/** Trámite del catálogo asociado a este servicio en el panel (o null). */
const tramiteServicio = computed(() => accesoSolicitud.tramiteDeServicio(Servicio.value))
/** El recuadro sale en los servicios con trámite; en los demás, solo si la notaría lo pide en el panel. */
const guiaTramite = computed(() => {
  const g = tramiteSeoPorCodigo(tramiteServicio.value ?? '')
  return g && accesoSolicitud.paginasTramite.value ? getLocalePath(`/tramites/${g.slug}`) : null
})
const mostrarSolicitud = computed(() => accesoSolicitud.visible('servicios') &&
  (!!tramiteServicio.value || store.NOTARIA?.SolicitudWeb?.MostrarEnServiciosSinTramite === true))
/** Documentación que pide la notaría para ese trámite (ya traducida por la API). */
const documentosTramite = computed(() =>
  tiposSolicitud.value.find((x: any) => x.codigo === tramiteServicio.value)?.documentos ?? [])

onMounted(() => {
  if (accesoSolicitud.visible('servicios') && tramiteServicio.value) cargarCatalogoSolicitud()
})

import { useStyles } from '../../store/styles';
const style = useStyles();

const isFromHomeExplicit = computed(() => route.query.from === 'home');
const isOnlyInHome = computed(() => {
  const currentSlug = route.params.id.toString();
  const currentSrv = store.NOTARIA?.Servicios?.find(s => s.Slug === currentSlug);
  return currentSrv?.MostrarHome && currentSrv?.MostrarEnSeccion === false;
});
const isFromHome = computed(() => isFromHomeExplicit.value || isOnlyInHome.value);

const publishedServices = computed(() => {
  if (isFromHome.value) {
    return store.NOTARIA?.Servicios?.filter(s => s.Publicado && s.MostrarHome) || []
  } else {
    return store.NOTARIA?.Servicios?.filter(s => s.Publicado && (s.MostrarEnSeccion || s.MostrarEnSeccion !== false)) || []
  }
})
const currentIndex = computed(() => publishedServices.value.findIndex(s => s.Slug === route.params.id.toString()))
const prevService = computed(() => currentIndex.value > 0 ? publishedServices.value[currentIndex.value - 1] : null)
const nextService = computed(() => currentIndex.value !== -1 && currentIndex.value < publishedServices.value.length - 1 ? publishedServices.value[currentIndex.value + 1] : null)

// const estiloTituloColor = style.ThemeSectionServicios.Titulo.css.Color
// const estiloTituloBackgroundColor = style.ThemeSectionServicios.Titulo.css.BackgroundColor
// const estiloTituloShadow = style.ThemeSectionServicios.Titulo.css.BackgroundColor ? "4px 2px 6px "+style.ThemeSectionServicios.Titulo.css.BackgroundColor:""
// const estiloTituloFont = style.ThemeSectionServicios.Titulo.css.Font
// const estiloTituloSize = style.ThemeSectionServicios.Titulo.css.Size
// const estiloTituloWeight = style.ThemeSectionServicios.Titulo.css.Weight
// const estiloTituloAlign = style.ThemeSectionServicios.Titulo.css.Align

// const estiloDescripcionColor = style.ThemeSectionServicios.Descripcion.css.Color
// const estiloDescripcionBackgroundColor = style.ThemeSectionServicios.Descripcion.css.BackgroundColor
// const estiloDescripcionShadow = style.ThemeSectionServicios.Descripcion.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Descripcion.css.BackgroundColor:""
// const estiloDescripcionFont = style.ThemeSectionServicios.Descripcion.css.Font
// const estiloDescripcionSize = style.ThemeSectionServicios.Descripcion.css.Size
// const estiloDescripcionWeight = style.ThemeSectionServicios.Descripcion.css.Weight
// const estiloDescripcionAlign = style.ThemeSectionServicios.Descripcion.css.Align

// const estiloTarjetaTituloColor = style.ThemeSectionServicios.Tarjeta.Titulo.css.Color
// const estiloTarjetaTituloShadow = style.ThemeSectionServicios.Tarjeta.Titulo.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Tarjeta.Titulo.css.BackgroundColor:""
// const estiloTarjetaTituloFont = style.ThemeSectionServicios.Tarjeta.Titulo.css.Font
// const estiloTarjetaTituloSize = style.ThemeSectionServicios.Tarjeta.Titulo.css.Size
// const estiloTarjetaTituloWeight = style.ThemeSectionServicios.Tarjeta.Titulo.css.Weight
// const estiloTarjetaTituloAlign = style.ThemeSectionServicios.Tarjeta.Titulo.css.Align

// const estiloTarjetaDescripcionColor = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Color
// const estiloTarjetaDescripcionShadow = style.ThemeSectionServicios.Tarjeta.Descripcion.css.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Tarjeta.Descripcion.css.BackgroundColor:""
// const estiloTarjetaDescripcionFont = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Font
// const estiloTarjetaDescripcionSize = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Size
// const estiloTarjetaDescripcionWeight = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Weight
// const estiloTarjetaDescripcionAlign = style.ThemeSectionServicios.Tarjeta.Descripcion.css.Align

const estiloTarjetaFondoColor = "linear-gradient(to right," +style.ThemeSectionServicios.Tarjeta.FondoCSS.BackgroundColor+","+style.ThemeSectionServicios.Tarjeta.FondoCSS.BackgroundColorGradient+")" 

const imgFiltro = computed(() => style.ThemeSectionServicios?.ImagenFiltro ? style.ThemeSectionServicios.ImagenFiltro : "")
const img = computed(() => {
  if (Servicio.value?.ImagenPortada) {
    return "url(" + imagenIDtoSRC(Servicio.value.ImagenPortada) + ")"
  }
  return style.ThemeSectionServicios?.Imagen ? "url(" + imagenIDtoSRC(style.ThemeSectionServicios.Imagen)+ ")" : ""
})

const estiloDetallesTituloBannerColor = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Color
const estiloDetallesTituloBannerShadow = style.ThemeSectionServicios.Detalles.TituloBannerCSS.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.TituloBannerCSS.BackgroundColor:""
const estiloDetallesTituloBannerFont = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Font
const estiloDetallesTituloBannerSize = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Size
const estiloDetallesTituloBannerWeight = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Weight
const estiloDetallesTituloBannerAlign = style.ThemeSectionServicios.Detalles.TituloBannerCSS.Align

const estiloDetallesSubtituloBannerColor = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Color
const estiloDetallesSubtituloBannerShadow = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.BackgroundColor:""
const estiloDetallesSubtituloBannerFont = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Font
const estiloDetallesSubtituloBannerSize = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Size
const estiloDetallesSubtituloBannerWeight = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Weight
const estiloDetallesSubtituloBannerAlign = style.ThemeSectionServicios.Detalles.SubtituloBannerCSS.Align

const estiloDetallesH1Color = style.ThemeSectionServicios.Detalles.H1.Color
const estiloDetallesH1Shadow = style.ThemeSectionServicios.Detalles.H1.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.H1.BackgroundColor:""
const estiloDetallesH1Font = style.ThemeSectionServicios.Detalles.H1.Font
const estiloDetallesH1Size = style.ThemeSectionServicios.Detalles.H1.Size
const estiloDetallesH1Weight = style.ThemeSectionServicios.Detalles.H1.Weight
const estiloDetallesH1Align = style.ThemeSectionServicios.Detalles.H1.Align

const estiloDetallesH2Color = style.ThemeSectionServicios.Detalles.H2.Color
const estiloDetallesH2Shadow = style.ThemeSectionServicios.Detalles.H2.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.H2.BackgroundColor:""
const estiloDetallesH2Font = style.ThemeSectionServicios.Detalles.H2.Font
const estiloDetallesH2Size = style.ThemeSectionServicios.Detalles.H2.Size
const estiloDetallesH2Weight = style.ThemeSectionServicios.Detalles.H2.Weight
const estiloDetallesH2Align = style.ThemeSectionServicios.Detalles.H2.Align

const estiloDetallesH3Color = style.ThemeSectionServicios.Detalles.H3.Color
const estiloDetallesH3Shadow = style.ThemeSectionServicios.Detalles.H3.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.H3.BackgroundColor:""
const estiloDetallesH3Font = style.ThemeSectionServicios.Detalles.H3.Font
const estiloDetallesH3Size = style.ThemeSectionServicios.Detalles.H3.Size
const estiloDetallesH3Weight = style.ThemeSectionServicios.Detalles.H3.Weight
const estiloDetallesH3Align = style.ThemeSectionServicios.Detalles.H3.Align

const estiloDetallesPColor = style.ThemeSectionServicios.Detalles.p.Color
const estiloDetallesPShadow = style.ThemeSectionServicios.Detalles.p.BackgroundColor ? "4px 2px 6px "+ style.ThemeSectionServicios.Detalles.p.BackgroundColor:""
const estiloDetallesPFont = style.ThemeSectionServicios.Detalles.p.Font
const estiloDetallesPSize = style.ThemeSectionServicios.Detalles.p.Size
const estiloDetallesPWeight = style.ThemeSectionServicios.Detalles.p.Weight
const estiloDetallesPAlign = style.ThemeSectionServicios.Detalles.p.Align

const estiloDetallesFondoBanner = "linear-gradient(to bottom," + style.ThemeSectionServicios.Detalles.FondoBannerCSS.BackgroundColor +" 0,"+ style.ThemeSectionServicios.Detalles.FondoBannerCSS.BackgroundColorGradient+" 100%)"

//////console.log(this.$route.params.id)
var slug:string = route.params.id.toString()
if(store.NOTARIA){
  Servicio.value = store.NOTARIA.Servicios.find(x => x.Slug === slug);
  if (!Servicio.value)
    router.push("/404")
  else if (!Servicio.value?.Publicado)
    router.push("/404")

}
const PageName = "Servicios"
// Cada servicio tiene su propio título, descripción e imagen (si no, todos compartirían los de la sección)
function seoServicio(): SeoPagina | undefined {
  const s: any = Servicio.value
  if (!s?.Titulo) return undefined
  // «… en Murcia» solo en español: en otros idiomas el «en» no vale
  const ciudad = (store.idioma || 'es') === 'es' ? store.NOTARIA?.Contacto?.Municipio : null
  const titulo = ciudad && !s.Titulo.toLowerCase().includes(ciudad.toLowerCase()) ? `${s.Titulo} en ${ciudad}` : s.Titulo
  const imagen = imagenIDtoSRC(s.ImagenPortada || s.Imagen)
  return {
    title: titulo,
    description: recortar(textoPlano(s.Extracto || s.Subtitulo || s.Contenido), 155),
    image: imagen.startsWith('http') ? imagen : undefined,
    publishedTime: fechaIso(s.Fecha),
    nombre: s.Titulo,
    schema: 'Service'
  }
}
// Slug de este servicio en cada idioma (se traducen), para los hreflang
const slugsSeo = useState<any>('seoSlugs', () => null)
if (!slugsSeo.value) slugsSeo.value = await $fetch(`/_seo/slugs.json?host=${encodeURIComponent(store.host)}`).catch(() => ({}))
function rutasServicio(): Record<string, string> | undefined {
  const slugs = slugsSeo.value?.servicios?.[(Servicio.value as any)?.id]
  return slugs ? Object.fromEntries(Object.entries(slugs).map(([l, s]) => [l, `/servicios/${s}`])) : undefined
}
if(store.NOTARIA) useMetaTags(toRaw(store.NOTARIA),PageName,slug,{ ...seoServicio(), rutasPorIdioma: rutasServicio() })
</script>
<style lang="scss">
.servicio-solicitud {
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 16px;
  padding: 24px 28px; border-radius: 14px; background: #f5f7f9; border: 1px solid #e3e7ea;
  &__cuerpo { flex: 1 1 360px; min-width: 0; }
  &__titulo { font-size: 1.15rem; font-weight: 600; margin: 0 0 4px; color: #1d2329; }
  &__texto { margin: 0; color: #5f6b76; }
  &__guia { display: inline-block; margin-top: 12px; font-size: .92rem; text-decoration: underline; color: inherit; }
  &__docs { margin-top: 16px; }
  &__docs-titulo { margin: 0 0 8px; font-weight: 600; color: #1d2329; }
  &__docs ul { list-style: none; padding: 0; margin: 0; display: grid; gap: 6px; }
  &__docs li { display: flex; align-items: flex-start; gap: 8px; color: #1d2329; line-height: 1.4;
    .v-icon { color: rgb(var(--v-theme-primary)) !important; margin-top: 1px; }
    em { font-style: normal; color: #5f6b76; font-size: 0.9em; } }
  &__docs-nota { margin: 10px 0 0; font-size: 0.88rem; color: #5f6b76; }
  &__boton {
    display: inline-flex; align-items: center; min-height: 48px; padding: 0 26px; border-radius: 999px;
    background: rgb(var(--v-theme-primary)); color: rgb(var(--v-theme-on-primary)) !important;
    font-weight: 600; text-decoration: none !important; white-space: nowrap;
    &:hover, &:focus-visible { filter: brightness(1.08); }
  }
}

  .banner-service-details-notin h2{
    color:v-bind(estiloDetallesTituloBannerColor)  !important;
    text-shadow:v-bind(estiloDetallesTituloBannerShadow)  !important;
    font-family:v-bind(estiloDetallesTituloBannerFont)  !important;
    font-size: v-bind(estiloDetallesTituloBannerSize) !important;
    font-weight:v-bind(estiloDetallesTituloBannerWeight) !important;
    text-align: v-bind(estiloDetallesTituloBannerAlign) !important;
  }
  .banner-service-details-notin h3{
    color:v-bind(estiloDetallesSubtituloBannerColor)  !important;
    text-shadow:v-bind(estiloDetallesSubtituloBannerShadow)  !important;
    font-family:v-bind(estiloDetallesSubtituloBannerFont)  !important;
    font-size: v-bind(estiloDetallesSubtituloBannerSize) !important;
    font-weight:v-bind(estiloDetallesSubtituloBannerWeight) !important;
    text-align: v-bind(estiloDetallesSubtituloBannerAlign) !important;
  }
  .banner-service-details-notin{
    background: v-bind(estiloDetallesFondoBanner) !important;
  }
  .content-service-details-notin h1{
    color:v-bind(estiloDetallesH1Color)  !important;
    text-shadow:v-bind(estiloDetallesH1Shadow)  !important;
    font-family:v-bind(estiloDetallesH1Font)  !important;
    font-size: v-bind(estiloDetallesH1Size) !important;
    font-weight:v-bind(estiloDetallesH1Weight) !important;
    text-align:v-bind(estiloDetallesH1Align) !important;
  }
  .content-service-details-notin h2{
    color:v-bind(estiloDetallesH2Color)  !important;
    text-shadow:v-bind(estiloDetallesH2Shadow)  !important;
    font-family:v-bind(estiloDetallesH2Font)  !important;
    font-size: v-bind(estiloDetallesH2Size) !important;
    font-weight:v-bind(estiloDetallesH2Weight) !important;
    text-align:v-bind(estiloDetallesH2Align) !important;
  }
  .content-service-details-notin h3, .content-service-details-notin a{
    color:v-bind(estiloDetallesH3Color)  !important;
    text-shadow:v-bind(estiloDetallesH3Shadow)  !important;
    font-family:v-bind(estiloDetallesH3Font)  !important;
    font-size: v-bind(estiloDetallesH3Size) !important;
    font-weight:v-bind(estiloDetallesH3Weight) !important;
    text-align:v-bind(estiloDetallesH3Align) !important;
  }
  .content-service-details-notin p{
    color:v-bind(estiloDetallesPColor)  !important;
    text-shadow:v-bind(estiloDetallesPShadow)  !important;
    font-family:v-bind(estiloDetallesPFont)  !important;
    font-size: v-bind(estiloDetallesPSize) !important;
    text-align:v-bind(estiloDetallesPAlign) !important;
  }
</style>
